/**
 * Nhãn gói hiển thị cho phòng khám đang đăng nhập — MỘT nguồn cho mọi màn (#19596).
 *
 * <p><b>Bốn nơi, ba nguyên nhân khác nhau.</b> QA báo (09/10) rằng một phòng khám đang trả gói
 * "Chuyên nghiệp" thấy bốn câu trả lời khác nhau. Truy nguồn riêng từng nơi — đúng như chủ sản
 * phẩm dặn, đừng mặc định cả bốn cùng một lỗi — cho ra:
 *
 * <ul>
 *   <li>`/settings/subscription` đọc `current.planName`, tên do quản trị viên nền tảng đặt → hiện
 *       "Chuyên nghiệp". <b>Đúng.</b>
 *   <li>`/settings/billing` in thẳng `planCode` → hiện "PRO". Sai CÁCH TRÌNH BÀY, không sai dữ
 *       liệu: chính hợp đồng của `PlanSummary.name` đã viết "Tên do quản trị viên nền tảng đặt —
 *       thứ hiển thị. `code` chỉ để gửi lại máy chủ."
 *   <li>Huy hiệu cạnh logo là một chuỗi <b>viết cứng</b> `"Lite"` trong `AppShell` — không đọc gói
 *       từ đâu cả. Nó là vết tích từ thời sản phẩm tên là "HIS Lite", và nó nói "Lite" cho MỌI
 *       phòng khám trên MỌI màn.
 *   <li>Khung "LITE" bên Addy Sites đọc `tenants.isPro`, do HIS đẩy qua `hisSync`. Đường ống đó
 *       hoàn chỉnh (gán gói → `tenant.entitlement.changed.v1` → `syncEntitlement`), nên đó là câu
 *       hỏi về DỮ LIỆU của tenant, không phải thiếu mã.
 * </ul>
 *
 * <p>Hàm này chỉ giải quyết hai nơi của HIS, và cố ý là một hàm THUẦN để ghim được luật mà không
 * cần dựng cả vỏ ứng dụng trong jsdom.
 */
export interface PlanNameSource {
  planName?: string | null;
  planCode?: string | null;
}

/**
 * Nhãn để hiện, hoặc {@code null} nghĩa là <b>không hiện gì</b>.
 *
 * <p><b>Chưa biết thì không hiện.</b> Chủ sản phẩm chốt 24/10: "khi chưa tải được gói, không mặc
 * định hiển thị Lite". Một nhãn đoán sai còn tệ hơn một chỗ trống, vì phòng khám đọc nó như một
 * câu khẳng định về thứ họ đang trả tiền.
 *
 * <p><b>Mã nội bộ không phải nhãn.</b> Thiếu tên thì trả {@code null} chứ không in `planCode`:
 * "PRO" cạnh logo là đúng cái đang gây hiểu nhầm. Mã vẫn giữ nguyên trong dữ liệu và vẫn là thứ
 * gửi lại máy chủ — chỉ không bày ra như tên gói.
 */
export function planLabel(sub: PlanNameSource | null | undefined, loading = false): string | null {
  if (loading || !sub) {
    return null;
  }
  const name = sub.planName?.trim();
  return name ? name : null;
}
